export enum LoyaltySignupMode {
  Simple = 'simple',
  InstantEnroll = 'instant-enroll',
}
